import React from 'react'
import './About.css'
import image2 from '../../assets/1739276909146.jpg'
import image4 from '../../assets/1739277535479.jpg'
import image1 from '../../assets/1739348196569.jpg'
import image3 from '../../assets/1739277824887.jpg'

const About = () => {
  return (
    <div className='about'>
        <div className="left-r">
            <img src={image4} alt="" />
            <img src={image2} alt="" />
            <img src={image1} alt="" />
            <img src={image3} alt="" />
        </div>
        <div className="right-r">
            <span>about us</span>

         <div className='who'>
            <span>who are</span>
            <span>  we</span>
         </div>
         <div className="details-r">
            {/*vision*/}
            <span className='vision'>Vision Statement</span>
            <p>To transform lives and build a self-substaining, empowering community.</p>
            {/*object*/}
            <span className='object'>Main Objectives</span>
            <p>EWCDC is a <span className='high'>public,non-public organisation </span>dedicated to fostering an <span className='high'>independent,self-sustainable,and entrepreneurial</span> community by focusing on the following key areas:</p>
            {/* early childhood*/}
            <span className='pro'>Early Childhood Development and Education</span>
            <p>- Provide <span className='high'>structured early childhood development (ECD) programs</span>to ensure a strong foundation for children's growth and learning.</p>
            <p>- Creat a <span className='high'>safe and nurturing enviroment</span>that support cognitive,social,and emotional development.</p>
            {/* after-care services*/}
            <span className='after'>After-Care Services for School-Going Children</span>
            <p>- Offer <span className='high'>homework assistance, life skills training, and mentorship</span>to children aged 6-18 years.</p>
            <p>- Provides a <span className='high'>structured after-school program </span>that fosters academic success and personal development.</p>
            {/* youth and parental*/}
            <span className="youth">Youth and Parental Empowerment</span>
            <p>- Equip <span className='high'>youth and parents</span>with <span className='high'>leadership,entrepreneurship,and financial literacy skills.</span></p>
            <p>- Promote <span className='high'>sustainable agricultures practices</span>through hands-on training and mentorship.</p>
            {/* spiritual*/}
            <span className="spirit">Spiritual Growth and Community Outreach</span>
            <p>- Implement <span className='high'>Children's Ministry Outreach programs</span> to nurture spiritual and moral development.</p>
            <p>- Engage <span className="high">community members</span>in faith-based activities and church partnership to promote spiritual growth</p>
         </div>
         <span
         style={{
            color: "{limegreen}",
            fontweight: "normal",
         }}
         >
            our partners
         </span>
         <div className="span">
         <span>- The AfM of SA- God's Ark Assembly</span>
         <span> - Local churches</span>
         <span> - Dienstenbureau Christelijke Gereformmeered kerken</span>
         <span> - Judeas Harvest</span>
         <span> - Abbas Pride</span>
         <span> - Hope Academic and Skill Center</span>
         <span> - The AFM of SA- National Welfare Department</span>
         <span> - Tswelopele ECD Association</span>
         </div>
        
        </div>
    </div>
  )
}

export default About